/**
 * Internal dependencies
 */
import WMUBlockArchive from "./block-archive";
import ViewportManager from "./viewport-manager";

/**
 * 
 */
class BlockArchiveManager {

	/**
	 * 
	 */
	constructor()
	{
		this.init();

		this.archiveList = [];
		this.archiveSelector = '.wmu-block.block-archive';
	}

	/**
	 * 
	 */
	init()
	{
		this.onViewportChange = this.onViewportChange.bind( this );
		document.addEventListener( 'WMUViewportChange', this.onViewportChange );
	}

	/**
	 * 
	 */
	clear()
	{
		const removeList = [];

		this.archiveList.forEach( ( archive ) =>
		{
			/**
			 * @todo Ajouter le cas où itemDisplayMode est différent ?
			 */
			if ( -1 === archive.viewports.indexOf( ViewportManager.viewportCurrent ) )
			{
				removeList.push( archive );
			}
		} );

		removeList.forEach( ( archive ) =>
		{
			archive.clear();
			archive.element.wmuBlockArchive = null;
			this.archiveList.splice( this.archiveList.indexOf( archive ), 1 );
		} );
	}

	/**
	 * 
	 */
	setup( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document;
		}

		/**
		 * 
		 */
		const elements = contextElement.querySelectorAll( this.archiveSelector );

		elements.forEach( ( element ) =>
		{
			if ( element.wmuBlockArchive )
			{
				return;
			}

			let queryAttribute = element.getAttribute( 'query' );
			queryAttribute = ( queryAttribute ) ? JSON.parse( queryAttribute ) : null;
			
			if ( null === queryAttribute )
			{
				return;
			}

			queryAttribute = queryAttribute.find( ( value ) => value.viewports.indexOf( ViewportManager.viewportCurrent ) !== -1 );
			
			if ( ! queryAttribute )
			{
				return;
			}

			let extraRequestArgs = element.getAttribute( 'extra-request-args' );
			extraRequestArgs = ( extraRequestArgs ) ? JSON.parse( extraRequestArgs ) : {};

			const displayMode = element.getAttribute( `${ViewportManager.getCurrentViewport()}-display-mode` );
			const itemDisplayMode = element.getAttribute( `${ViewportManager.getCurrentViewport()}-item-display-mode` );
			const context = ( itemDisplayMode ) ? itemDisplayMode : element.getAttribute( 'context' );
			const highlightDisplayMode = element.getAttribute( `${ViewportManager.getCurrentViewport()}-hl-display-mode` );
			const highlightItemDisplayMode = element.getAttribute( `${ViewportManager.getCurrentViewport()}-hl-item-display-mode` );
			const highlightCount = element.getAttribute( `${ViewportManager.getCurrentViewport()}-hl-count` );

			if ( queryAttribute.highlights )
			{
				extraRequestArgs = {
					highlightDisplayMode: highlightDisplayMode,
					highlightItemDisplayMode: highlightItemDisplayMode,
					highlightCount: highlightCount,
					...extraRequestArgs
				};
			}

			const blockArchive = new WMUBlockArchive( element, {
				url: wmuwpb.ajaxUrl,
				nonce: wmuwpb.blockArchive.nonce,
				action: wmuwpb.blockArchive.action,
				filterInputSelector: '.block-archive-filter-input',
				filterResetSelector: '.reset-filters',
				filtersFormSelector: '.block-archive-filters-form',
				highlightsWrapperSelector: '.block-archive-highlights',
				itemWrapperSelector: '.block-archive-items',
				loaderSelector: '.block-archive-loader',
				loaderWrapperSelector: '.block-archive-loader-wrapper',
				viewports: queryAttribute.viewports,
				queryArgs: queryAttribute.query_args,
				highlights: queryAttribute.highlights,
				highlightCount: highlightCount,
				requestArgs: {
					from: 'wmublocks/archive',
					highlights: queryAttribute.highlights,
					context: context,
					displayMode: displayMode,
					itemDisplayMode: itemDisplayMode,
					...extraRequestArgs
				}
			} );

			this.archiveList.push( blockArchive );
			element.wmuBlockArchive = blockArchive;

			/**
			 * Event relay
			 */
			blockArchive.addEventListener( 'itemAdded', ( event ) => window.dispatchEvent( new CustomEvent( 'wmuwpblocks/archive/itemAdded', {
				detail: {
					item: event.detail,
					archive: event.target,
					originalEvent: event,
				}
			} ) ) );

			blockArchive.addEventListener( 'itemsAdded', ( event ) => window.dispatchEvent( new CustomEvent( 'wmuwpblocks/archive/itemsAdded', {
				detail: {
					item: event.detail,
					archive: event.target,
					originalEvent: event,
				}
			} ) ) );
		} );
	}

	/**
	 * 
	 * @param {*} event 
	 */
	onViewportChange( event )
	{
		this.clear();
		this.setup();
	}

}

export default BlockArchiveManager;